function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;

      const sliderDots = document.querySelector(".slider-dots-wrapper");
      const allDots = sliderDots.querySelectorAll("li");
      allDots[this.currentPage - 1].classList.add("active");
      allDots.forEach((dot, index) => {
        if (index != this.currentPage - 1) {
          dot.classList.remove("active");
        }
      });
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// all custom javascript

const bannerSliders = document.querySelectorAll(".banner-collection-slider");
const bannerSlidersNextButton = document.querySelectorAll(
  ".banner-slider-next"
);

bannerSlidersNextButton.forEach((button, index) => {
  button.addEventListener("click", () => {
    const itemWidth =
      bannerSliders[index].querySelector("li").clientWidth + 110;
    bannerSliders[index].scrollLeft += itemWidth;
  });
});

// cart slider
const cartUpsell = document.querySelector(".cart_upsell");
let cartUpsellPrevButton = document.querySelector(".cart-upsell-prev-button");
let cartUpsellNextButton = document.querySelector(".cart-upsell-next-button");
let cartUpsellSlider = document.querySelector(".cart_upsell_slider");

function cartUpsellScrollLeft() {
  let cartUpsellSlider = document.querySelector(".cart_upsell_slider");
  cartUpsellSlider.scrollLeft += cartUpsellSlider.scrollWidth / 2;
}

function cartUpseelScrollRight() {
  let cartUpsellSlider = document.querySelector(".cart_upsell_slider");
  cartUpsellSlider.scrollLeft -= cartUpsellSlider.scrollWidth / 2;
}

//  remove same item from cart

// async function removeSameProduct() {
//   const bulkAddButton = document.querySelector('.bulk-add-to-cart')
//   const bulkAddButtonText = bulkAddButton.querySelector('span')
//   bulkAddButtonText.innerText = 'UPDATE YOUR SHADES'
//   const removeItemFromCart = await fetch('/cart.js  ', {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json"
//     }
//   }).then( (res) => {
//     const response = res.json()
//     return response
//   }).then ( (data) => {
//     return data
//   })

//   const itemsInCart = await removeItemFromCart.items
//   itemsInCart.forEach((item, index) => {
//     let productId = parseInt(bulkAddButton.dataset.productid)
//     let itemKey = item.key
//     let data = {
//         'id': itemKey,
//         'quantity': 0,
//         "sections" : ['cart-drawer', "cart-icon-bubble"]
//     }

//     if(item.id === productId ) {

//         fetch(`/cart/change.js`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(data),
//         })
//         .then((response) => {
//           // Handle successful update
//           console.log('Cart updated successfully!', response);
//         })
//         .catch((error) => {
//           // Handle error
//           console.error(error);
//         });

//     }
//   })
// }

//  remove upsell items from the cart if  only upsell items contains
// console.clear()

// function clearCart() {
//   fetch('/cart/clear.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       updates: {},
//     })
//   })
//   .then(() => {
//     // Handle successful clearing
//     console.log('Cart cleared!');
//     location.reload()
//     // Update your UI or redirect to cart page
//   })
//   .catch((error) => {
//     console.error(error);
//   });
// }

// function removeUpsellOnly(value) {
//   const cartRemoveButtons = document.querySelectorAll('.cart-remove-button').length
//   const upsellRemoveButtons = document.querySelectorAll('.cart-remove-button-data-cartupsell').length
//   const getCheckoutButton = document.querySelector('#CartDrawer-Checkout')
//   const cartDrawer = document.querySelector('cart-drawer')

//   console.log(value, cartRemoveButtons, upsellRemoveButtons)

//   if(value === false && cartRemoveButtons <= 1) {
//     getCheckoutButton.style.display = 'none'
//     cartDrawer.classList.remove('active')
//    let timeout =  setTimeout(() => {
//       clearCart()
//     },950)
//   }

// }

// get cart data

// custom cart button
const bulkAddCartButton = document.querySelector(".bulk-add-to-cart");
const virutalCartButton = document.querySelector(".virtual-cart-button");
const stkCartBtn = document.querySelector(".virtual-sticky-add-to-cart");
let virtualDrawerCart = document.querySelector(".drawer-virtual-checkout");

async function getCartData() {
  const cart = await fetch("/cart.js", {
    method: "GET",
  })
    .then((res) => {
      const response = res.json();
      return response;
    })
    .then((data) => {
      return data;
    });

  return cart.items;
}

//  removeSameItemFromCart

async function removeSameItem(itemKey) {
  let data = {
    id: itemKey,
    quantity: 0,
    sections: ["cart-drawer", "cart-icon-bubble"],
  };

  const removeSameItemFromCart = await fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      // Handle successful update
      if (response.ok) {
        bulkAddCartButton.click();
        setTimeout(() => {
          virutalCartButton.classList.remove("loading");
          stkCartBtn.classList.remove("loading");
        }, 1000);
      }
      console.log("Cart updated successfully!", response);
    })
    .catch((error) => {
      // Handle error
      console.error(error);
      virutalCartButton.classList.remove("loading");
      stkCartBtn.classList.remove("loading");
    });
  return removeSameItemFromCart;
}

// VIRTUAL CART BUTTON
async function virtualCartClick(productVariantId) {
  virutalCartButton.classList.add("loading");
  stkCartBtn.classList.add("loading");
  let isSameItemInCart = false;
  virutalCartButton.querySelector(".virtual-cart-text").innerText =
    "UPDATE YOUR SHADES";
  stkCartBtn.querySelector(".virtual-cart-text").innerText =
    "UPDATE YOUR SHADES";

  const cartItems = await getCartData();
  cartItems.forEach((item) => {
    if (item.id === productVariantId) {
      const removeSameProductFromCart = removeSameItem(item.key);
      isSameItemInCart = true;
    }
  });

  if (!isSameItemInCart) {
    bulkAddCartButton.click();
    setTimeout(() => {
      virutalCartButton.classList.remove("loading");
      stkCartBtn.classList.remove("loading");
    }, 500);
  }
}

// upsell item not pass in checkout

function upSellShouldNotPass() {
  virtualDrawerCart = document.querySelector(".drawer-virtual-checkout");
  // virtualDrawerCart.disabled = true;

  const cartRemoveButtons = document.querySelectorAll(
    ".cart-remove-button"
  ).length;
  const upsellRemoveButtons = document.querySelectorAll(
    ".cart-remove-button-data-cartupsell"
  ).length;
  const cartDrawer = document.querySelector("cart-drawer");
  const upsellOnlyWarning = document.querySelector(".upsell-only-alert");

  if (cartRemoveButtons === 0) {
    upsellOnlyWarning.innerText =
      "🛑 Items in your cart are not applicable for checkout please add more items to checkout.";
  } else {
    // drawerCheckoutButton.click()
    virtualDrawerCart.classList.add("loading");
    virtualDrawerCart.querySelector(".text").innerText =
      "🛍️ Preparing Your Cart ...";
    addSelectedShades();

    setTimeout(() => { 
      virtualDrawerCart.classList.remove("loading");
      virtualDrawerCart.querySelector(".text").innerText = "BUY NOW"


    }, 3000)
  }

  // virtualDrawerCart.querySelector('.text').innerText = '🛍️ Preparing Your Cart ...'
}

// add all the diffrent shades selected by users

async function addSelectedShades() {
  const isCartContainsBulkProduct = document.querySelectorAll(
    ".cart-contains-bulk-add"
  ).length;
  const drawerCheckoutButton = document.querySelector(".sr-headless-checkout");

  virtualDrawerCart.classList.add("loading");
  virtualDrawerCart.querySelector(".text").innerText =
    "🛍️ Preparing Your Cart ....";

  if (isCartContainsBulkProduct) {
    const cartItems = await getCartData();
    let variantsIds = [];
    cartItems.forEach((item) => {
      const properties = item.properties;
      const varIds = Object.values(properties);
      if (varIds.length) {
        variantsIds.push(...varIds);
      }
    });

    updateCartWithShades(variantsIds);
  } else {
    drawerCheckoutButton.click();
  }
}

//  click on shiprocket checkout button on first load

function clickOnFastrrCheckout() {
  const drawerCheckoutButton = document.querySelector(".sr-headless-checkout");

  if (drawerCheckoutButton) {
    drawerCheckoutButton.click();
  } else {
    setTimeout(() => {
      clickOnFastrrCheckout();
    }, 400);
  }
}

//  update cart with shades

// async function updateCartWithShades(varIds) {
//   const drawerCheckoutButton = document.querySelector(".sr-headless-checkout");
//   const convertedArray = [];

//   for (const item of varIds) {
//     convertedArray.push({
//       quantity: 1,
//       id: parseInt(item),
//     });
//   }
//   const data = {
//     items: [...convertedArray],
//   };

//   const addShadesToCart = await fetch("/cart/add.js", {
//     method: "POST",
//     body: JSON.stringify(data),
//     headers: {
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       console.error(error);
//       console.log('not workinggg')
//     });

//   // alert('drawercheckout click')

//   if (drawerCheckoutButton) {
//     drawerCheckoutButton.click();
//   } else {
//     clickOnFastrrCheckout();
//   }
// }


let failedCount = 0
async function updateCartWithShades(varIds) {
  const drawerCheckoutButton = document.querySelector(".sr-headless-checkout");
  const convertedArray = [];


  const getCartItems = await getCartData()
  console.log(getCartItems, 'vishwajeet this is data')

  const itemsToRemove = getCartItems.filter(item => ( item.product_type === "bundle" || item.price == 0 ));

  if(itemsToRemove.length >= 1) { 
    
    let updates = {
    };
    
    for (const item of itemsToRemove) {
      updates[item.id] = 0;
  
    }

  const removeItems = await  removeFreeItems(updates)

  if (removeItems.status == 200) { 

    for (const item of varIds) {
      convertedArray.push({
        quantity: 1,
        id: parseInt(item),
      });
    }
    const data = {
      items: [...convertedArray],
    };
    
  
    try {
      const addShadesToCart = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!addShadesToCart.ok) {
        throw new Error('Failed to add items to cart');
      }
  
      if (drawerCheckoutButton) {
        drawerCheckoutButton.click();
      } else {
        clickOnFastrrCheckout();
      }
    } catch (error) {
      console.error(error);
      console.log('Adding to cart failed. Retrying..vsssf.');
  
      // Retry the whole function call after a delay (e.g., 3 seconds)
      await new Promise(resolve => setTimeout(resolve, 3000));
      await updateCartWithShades(varIds);
    }
    
  }
 


  }else { 

    for (const item of varIds) {
      convertedArray.push({
        quantity: 1,
        id: parseInt(item),
      });
    }
    const data = {
      items: [...convertedArray],
    };
  
    try {
      const addShadesToCart = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!addShadesToCart.ok) {
        throw new Error('Failed to add items to cart');
      }
  
      if (drawerCheckoutButton) {
        drawerCheckoutButton.click();
      } else {
        clickOnFastrrCheckout();
      }
    } catch (error) {
      console.error(error);
      failedCount++
      if(failedCount == 2) { 
        window.location.reload()
      }
      console.log('Adding to cart failed. Retrying..vvvv.');
  
      // Retry the whole function call after a delay (e.g., 3 seconds)
      await new Promise(resolve => setTimeout(resolve, 3000));
      await updateCartWithShades(varIds);
    }

  }


}
  

//  remove free ites from cart
async function removeFreeItems(updates) { 
  const removeFreeItemsFromCart = await fetch("/cart/update.js", {
    method: "POST",
    body: JSON.stringify({updates} ),
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then((res) => {
      console.log(res.json(), 'sdfsdfsdfsdlfsdkjsdffds')
      return res
    })
    .catch((error) => {
      console.error(error);
    });

    return removeFreeItemsFromCart
}

async function removeZeroPriceProduct() {
  const hiddenProducts = document.querySelectorAll("tr[data-product-remove]");
  let hiddenProductIdArr = [];
  let isFreeItemsInCart = false;


  if (hiddenProducts.length) {
    isFreeItemsInCart = true;
    hiddenProducts.forEach((product) => {
      hiddenProductIdArr.push(product.dataset.productRemove);
    });

    let updates = {};

    for (const item of hiddenProductIdArr) {
      updates[item] = 0;
    }
    const removeFreeItemsFromCart = await  removeFreeItems(updates) 
    console.log(removeFreeItemsFromCart.status, 'vishsajsß')
    if(removeFreeItemsFromCart.status == 200) { 
      window.location.reload()
    }else { 
      fetch('/cart/clear.js')
    }


  }
}

removeZeroPriceProduct();

// end remove free items from cart

//  sticky cart show on page
let isBulkBuyButtonOnScreen = document.querySelector(".virtual-cart-button") || document.querySelector('.virtual-cart-button-foundation')
if (isBulkBuyButtonOnScreen) {
  document.addEventListener("scroll", () => {
    // console.dir(isBulkBuyButtonOnScreen.offsetTop)
    if (window.scrollY >= isBulkBuyButtonOnScreen.offsetTop * 2) {
      document.querySelector(".sticky-cart-wrapper ").classList.add("active");
    } else {
      document
        .querySelector(".sticky-cart-wrapper ")
        .classList.remove("active");
    }
  });
}

/** ================================ bulk add js start ================================================ */
let cartButton;
let virtualCart;
let bulkAddForm;
let stickyCart;

console.log("loaddeeddd ==========================");

// console.log(limit, 'limit')
const allShades = document.querySelectorAll(".custom_input");
const finalShades = document.querySelectorAll(".selected_shade_box");
const crosses = document.querySelectorAll(".cross");
const mediaGallary = document.querySelector(".product__media-list");
const shadeLeft = document.querySelector(".shade-left");
// cartButton = document.querySelector(".shopify-payment-button__button");
cartButton = document.querySelector(".bulk-add-to-cart");
virtualCart = document.querySelector(".virtual-cart-button");
stickyCart = document.querySelector(".virtual-sticky-add-to-cart");
bulkAddForm = document.querySelector("#bulk-add-form");
const stickyCartWrapper = document.querySelector(".sticky-cart-wrapper");
const normalStickyCartWrapper = document.querySelector(".sticky-cart-wrapper.normal");

//  listen on sticky cart button

if (stickyCartWrapper) {
  stickyCartWrapper.addEventListener("click", () => {
    if (stickyCart.disabled) {
      window.scrollTo({ top: 50, behavior: "smooth" });
    } else {
      return;
    }
  });

  stickyCartWrapper.addEventListener('touchstart', () => { 
    console.log('touch start')
    stickyCartWrapper.querySelector('button').click()
  })
  
}

if(normalStickyCartWrapper) { 
  normalStickyCartWrapper.addEventListener('click', () => { 
    const foundationBtn = document.querySelector('.virtual-cart-button-foundation')
    foundationBtn.click()
    console.log('click')

    normalStickyCartWrapper.querySelector('button').classList.add('loading')
    
    setTimeout(() => { 
      normalStickyCartWrapper.querySelector('button').classList.remove('loading')
    }, 3000)
  })
}

if (cartButton) {
  //some changes
  console.log(cartButton, "pointer events");
  // cartButton.style.pointerEvents =  "auto";
  // cartButton.style.visibility = "visible";
  cartButton.disabled = true;
  virtualCart.disabled = true;
  stickyCart.disabled = true;
}

let selectedShadesArray = [];

const showSelected = document.querySelector(".show-selected");

function updateImageOnSlider(shadeCode) {
  const mediaGallary = document.querySelector(".product__media-list");
  const images = mediaGallary.querySelectorAll("li");
  const findSelectedImage = mediaGallary.querySelector(
    `li[data-mediaalt="${shadeCode}"]`
  );
  const findActiveImage = mediaGallary.querySelector(".is-active");

  if (findSelectedImage) {
    mediaGallary.scrollLeft = findSelectedImage.offsetLeft;
    findActiveImage.classList.remove("is-active");
    findSelectedImage.classList.add("is-active");
  }
}

function updateActiveImage(code, lowres, hires) {
  let getAllLi = mediaGallary.querySelectorAll("li");
  let updateFirstLiImage = getAllLi[0].querySelector("img");
  let productSlider = document.querySelector(".product__media-list");

  productSlider.scrollLeft = 0;

  updateFirstLiImage.src = "";
  updateFirstLiImage.srcset = "";
  updateFirstLiImage.src = lowres;
  updateFirstLiImage.src = hires;
}

allShades.forEach((shade) => {
  shade.disabled = false;
});

// select one by default
// allShades[0].checked = true
// selectFiveShade(allShades[0])
allShades.forEach((shade) => {
  shade.addEventListener("click", (e) => {
    selectFiveShade(shade);
  });
});

// function one
function selectFiveShade(shade) {
  const shadeValue = {
    shade_name: shade.dataset.name,
    shade_id: shade.dataset.id,
    shade_image: shade.dataset.image,
    shade_code: shade.dataset.code,
    shade_hires: shade?.dataset?.hires,
  };

  const checkAlreadyContain = selectedShadesArray.some(
    (shade) => shade.shade_id === shadeValue.shade_id
  );
  const selectedIndex = selectedShadesArray.findIndex(
    (obj) => obj.shade_id === shade.dataset.id
  );

  if (!checkAlreadyContain && selectedShadesArray.length != limit) {
    selectedShadesArray.push(shadeValue);
    updateShowSelected();
    updateFinalShadesColor();
    // updateActiveImage(shadeValue.shade_code, shadeValue.shade_image, shadeValue.shade_hires)
    updateImageOnSlider(shadeValue.shade_code);
    const shadesToadd = selectedShadesArray.length - limit;
    shadeLeft.innerText = Math.abs(shadesToadd);
    // update name and value
    shade.name = `properties[${shadeValue.shade_name}]`;
    shade.value = shade.dataset.sku;

    if (selectedShadesArray.length === limit) {
      toggleInput(true);
      document.querySelector(".choose-shade-warning").style.display = "none";
    }
  } else {
    selectedShadesArray.splice(selectedIndex, 1);
    updateFinalShadesColor();
    updateShowSelected();
    toggleInput(false);
    document.querySelector(".choose-shade-warning").style.display = "inherit";

    const shadesToadd = selectedShadesArray.length - limit;
    shadeLeft.innerText = Math.abs(shadesToadd);

    // remove name and value
    shade.name = "";
    shade.value = "";
  }

  console.log(selectedShadesArray);
}

// function two disable & enables shades
function toggleInput(toggleValue) {
  allShades.forEach((shade) => {
    if (toggleValue) {
      if (!shade.checked) {
        shade.disabled = true;
        cartButton.disabled = false;
        virtualCart.disabled = false;
        stickyCart.disabled = false;
        shade.parentElement.style.opacity = 0.5;
      }
    } else {
      shade.disabled = false;
      cartButton.disabled = true;
      virtualCart.disabled = true;
      stickyCart.disabled = true;
      shade.parentElement.style.opacity = 1;
    }
  });
}

// function three update final kit
function updateFinalShadesColor() {
  finalShades.forEach((shade, index) => {
    const shadeColor = selectedShadesArray[index]?.shade_image || null;
    const addDataList = shade.querySelector(".cross");
    if (!shadeColor) {
      shade.style.background = "white";
      shade.classList.remove("active");
    } else {
      shade.style.background = `${shadeColor}`;
      shade.style.background = `url('${selectedShadesArray[index]?.shade_image}')`;
      shade.classList.add("active");
      addDataList.dataset.key = selectedShadesArray[index]?.shade_id;
    }
  });
}

//  function crosses

crosses.forEach((cross) => {
  cross.addEventListener("click", () => {
    let removeThisShade;
    allShades.forEach((shade) => {
      if (shade.dataset.id == cross.dataset.key) {
        removeThisShade = shade;
      }
    });
    removeThisShade.checked = false;
    selectFiveShade(removeThisShade);
  });
});

// show selected
function updateShowSelected() {
  let selectedShadeString = " ";
  for (const shade of selectedShadesArray) {
    selectedShadeString += `${shade.shade_name}, `;
  }
  showSelected.innerText = selectedShadeString;
}

// final function
//  add to cart button run shiprcoket checkout

// bulkAddForm.addEventListener('submit', (e) => {
//   e.preventDefault();
//   const checkoutEvent = e

//     function shiipRocketCheckout() {
//       HeadlessCheckout.checkout(checkoutEvent)
//     }

//     // get the form data
//     const form = document.querySelector('form[action="/cart/add"]')
//     const formData = new FormData(form)
//     const product_id = parseInt([...formData][2][1])

//     async function getCartData() {
//       const cartItems = fetch('/cart.js')
//       .then((res) => {
//         const response = res.json()
//         return response
//       })
//       .then((data) => {
//         const items = data.items
//           return items
//       })
//         return cartItems
//     }

//     async function updateShades() {
//       const lineItems = await getCartData()
//       let isSameItemInCart

//       if(lineItems) {
//         lineItems.forEach((ItemsInCart) => {
//           if(ItemsInCart.id === product_id) {
//             isSameItemInCart = ItemsInCart.key
//           }
//         })
//       }

//       if(lineItems.length > 0 && lineItems.length) {
//         if(isSameItemInCart) {
//           fetch(`/cart/change?id=${isSameItemInCart}&quantity=0`, {
//             method: 'POST'
//           })
//           .then((res) => {
//             if(res.ok){
//               console.log('removed')
//               shiipRocketCheckout()
//             }else {
//               console.log('error in removing item')
//             }
//           })
//         }else {
//           shiipRocketCheckout()
//         }

//       }else {
//         fetch('/cart.js')
//         .then((res) => {
//           if(res.ok) {
//             shiipRocketCheckout()
//           }
//         })
//       }
//     }

//     updateShades()

//   });

/** ================================ bulk add js end================================================ */

// **************************************************** Make Up Kit Start **********************************************************

async function removeSameMakeupItem(itemKey) {
  const buyform = document.querySelector(".org-buy-button");
  const addToCartButton = buyform.querySelector(".product-form__submit");
  const makeupKitButton = document.querySelector(".makeup-kit-button");

  let data = {
    id: itemKey,
    quantity: 0,
    sections: ["cart-drawer", "cart-icon-bubble"],
  };

  const removeSameMakeupItemFromCart = await fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      // Handle successful update
      if (response.ok) {
        addToCartButton.click();
        setTimeout(() => {
          makeupKitButton.classList.remove("loading");
        }, 1000);
      }
      console.log("Cart updated successfully!", response);
    })
    .catch((error) => {
      // Handle error
      console.error(error);
      makeupKitButton.classList.remove("loading");
    });
  return removeSameMakeupItemFromCart;
}

async function makeupkitbutton(productId) {
  const buyform = document.querySelector(".org-buy-button");
  const makeupKitButton = document.querySelector(".makeup-kit-button");
  const addToCartButton = buyform.querySelector(".product-form__submit");

  // new
  makeupKitButton.classList.add("loading");
  let isSameItemInCart = false;
  makeupKitButton.querySelector(".makeup-kit-button-text").innerText =
    "UPDATE YOUR KIT";

  const cartItems = await getCartData();
  cartItems.forEach((item) => {
    console.log(item, productId);
    if (item.product_id === productId) {
      const removeSameProductFromCart = removeSameMakeupItem(item.key);
      isSameItemInCart = true;
    }
  });

  if (!isSameItemInCart) {
    addToCartButton.click();
    setTimeout(() => {
      makeupKitButton.classList.remove("loading");
    }, 500);
  }
}

const imageVariants = document.querySelector(".image-variant-fieldset");

if (imageVariants) {
  const makeupKitSections = document.querySelectorAll(".makeup-kit-section");

  const selectedCheckbox = imageVariants.querySelector("input[checked]");

  makeupKitSections.forEach((kit, index) => {
    const allDialogs = kit.querySelectorAll("dialog");

    if (kit.dataset.variant == selectedCheckbox.value) {
      kit.style.display = "inline-block";
      console.dir(kit);

      const allInputs = kit.querySelectorAll("input");

      allInputs.forEach((input) => {
        input.disabled = false;
      });
    }
  });
}

if(imageVariants != null) { 

  imageVariants.addEventListener("change", (e) => {
    const makeupKitSections = document.querySelectorAll(".makeup-kit-section");
  
    makeupKitSections.forEach((section) => {
      if (section.dataset.variant === e.target.value) {
        section.style.display = "block";
  
        const inputs = section.querySelectorAll("input");
        inputs.forEach((input) => {
          input.disabled = false;
        });
      } else {
        section.style.display = "none";
  
        const inputs = section.querySelectorAll("input");
        inputs.forEach((input) => {
          input.disabled = true;
        });
      }
    });
  });

  const dialogsButtons = document.querySelectorAll('.select-shade-button')

  dialogsButtons.forEach((button) => { 
    button.addEventListener('click', () => { 
      const dialog = document.querySelector(`dialog#${button.dataset.dialog}`)
      const closesstInput = document.querySelector(`input[data-input="${button.dataset.dialog}"]`)
      const findSelectedInput = dialog.querySelector(`input[data-id="${closesstInput.value}"]`)
      findSelectedInput.checked  = true
    })
  })

  

}


const fieldsets = document.querySelectorAll(".dialog-fieldset");

if(fieldsets != null) { 

  fieldsets.forEach((field) => {
    field.addEventListener("change", (e) => {
      const fieldUniqeId = field.dataset.uniqueid;
      let kitProductBox = document.querySelector(
        `.kit-item-wrapper[data-product=${fieldUniqeId}]`
      );
      let kitProductTitle = kitProductBox.querySelector(
        ".kitbox-selected-variant"
      );
      let kitProductImage = kitProductBox.querySelector("img");
      let kitProductId = kitProductBox.querySelector(".id");
      let kitProductInputProperty = kitProductBox.querySelector('.input-with-variant')
  
      const inputs = field.querySelectorAll("input");
      
      const selectedInput = Array.from(inputs).find((input) => input.checked);
  
  
  
      kitProductImage.src = selectedInput.dataset.image;
      kitProductTitle.innerText = selectedInput.dataset.title;
      kitProductId.value = selectedInput.dataset.id;
      kitProductInputProperty.name = `properties[${kitProductInputProperty.dataset.product} => ${selectedInput.dataset.title}]`
  
      const closeDialog = document.querySelector(`#${fieldUniqeId}`);
      const closeButton = closeDialog.querySelector("button");
      closeButton.click();
    });
  });

}



// **************************************************** Make Up Kit End **********************************************************



// **************************************************** foundation virtua button start**********************************************************
async function foundationVirtualButtonClick() { 
  const foundationAddToCartBtn = document.querySelector('.custom-buy-button')
  const foundationVirtualBtn  = document.querySelector('.virtual-cart-button-foundation')
  foundationVirtualBtn.classList.add('loading')

  setTimeout(() => { 
    foundationVirtualBtn.classList.remove('loading')
  }, 5000)

  foundationAddToCartBtn.click()
}

// **************************************************** foundation virtua button end **********************************************************


// fix fastrr checkout issue 

function fixFunc() { 
  console.log('runnning ')
  removeZeroPriceProduct();
  window.setTimeout(() => {
    fixFunc()
  }, 1000);

}

fixFunc()